module.exports = __webpack_public_path__ + "img/razzo-head-page-2.91b852b9.png";